import { Link } from "react-router-dom";
import { CalendarCheck, Phone } from "lucide-react";

const RUNNING_WILD_LOGO =
  "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/bbbqebql_1.png";
const RUNNING_WILD_URL = "https://runningwildrescue.ca";

/**
 * Slide-down mobile navigation panel — shown when the hamburger menu is open.
 */
export default function MobileMenu({ navLinks, onClose }) {
  return (
    <div className="landing-header__mobile-panel" data-testid="mobile-menu-panel">
      <a
        href={RUNNING_WILD_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="landing-header__mobile-donate"
        onClick={onClose}
      >
        <span className="landing-header__donate-thumb">
          <img src={RUNNING_WILD_LOGO} alt="" loading="lazy" />
        </span>
        Donate to Running Wild Rescue
      </a>
      {navLinks.map((l) => (
        <a
          key={l.href}
          href={l.href}
          className="landing-header__mobile-link"
          onClick={onClose}
        >
          {l.label}
        </a>
      ))}
      <div className="landing-header__mobile-ctas">
        <a href="tel:3066910001" className="pp-btn-primary w-full" onClick={onClose}>
          <Phone className="w-4 h-4" />
          306-691-0001
        </a>
        <Link
          to="/book"
          className="pp-btn-confirm w-full"
          onClick={onClose}
          data-testid="mobile-menu-book-cta"
        >
          <CalendarCheck className="w-4 h-4" />
          Book online
        </Link>
      </div>
    </div>
  );
}
